module.exports = __webpack_public_path__ + "img/nfbz-table-2@2x.03f356c9.png";